import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import InstallBanner from './InstallBanner';

function LayoutComponent({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <a href="#main-content" className="sr-only focus:not-sr-only p-2">
        Skip to main content
      </a>
      <Header />
      <main
        id="main-content"
        role="main"
        className="container mx-auto flex-grow px-4 py-8"
      >
        {children}
      </main>
      <Footer />
      <InstallBanner />
    </div>
  );
}

export default memo(LayoutComponent);
